(function () {
  var section = document.querySelector('[data-recently-viewed]');
  var grid = document.querySelector('[data-recently-viewed-grid]');
  if (!section || !grid) return;
  var fallbackImage = grid.getAttribute('data-fallback-image');

  try {
    var items = JSON.parse(localStorage.getItem('lydia-recently-viewed') || '[]')
      .filter(function (item) { return item.url !== location.pathname; })
      .slice(0, 4);
    if (!items.length) return;

    grid.innerHTML = items.map(function (item) {
      var article = document.createElement('article');
      article.className = 'product-card';

      var mediaLink = document.createElement('a');
      mediaLink.href = item.url;
      var image = document.createElement('img');
      image.src = item.image;
      image.alt = item.title;
      image.loading = 'lazy';
      image.decoding = 'async';
      image.onerror = function () {
        if (fallbackImage && image.src !== fallbackImage) image.src = fallbackImage;
      };
      mediaLink.appendChild(image);

      var content = document.createElement('div');
      var heading = document.createElement('h3');
      var titleLink = document.createElement('a');
      titleLink.href = item.url;
      titleLink.textContent = item.title;
      heading.appendChild(titleLink);

      var price = document.createElement('p');
      price.className = 'card-price';
      price.textContent = item.price;

      var viewLink = document.createElement('a');
      viewLink.className = 'text-link';
      viewLink.href = item.url;
      viewLink.textContent = 'View product';

      content.appendChild(heading);
      content.appendChild(price);
      content.appendChild(viewLink);
      article.appendChild(mediaLink);
      article.appendChild(content);
      return article.outerHTML;
    }).join('');
    Array.prototype.forEach.call(grid.querySelectorAll('img'), function (image) {
      image.addEventListener('error', function () {
        if (fallbackImage && image.src !== fallbackImage) image.src = fallbackImage;
      });
    });
    section.hidden = false;
  } catch (error) {
    section.hidden = true;
  }
})();
